import React from 'react'

function HubCompanyView() {
    return (
        <div>HubCompanyView</div>
    )
}

export default HubCompanyView